import { faShareAll } from "@fortawesome/pro-light-svg-icons";
import { VaporIcon } from "@vapor/react-icons";
import { Button } from "@vapor/react-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { TaxSubmissionDetailDTO } from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";

import { IntermediaryType } from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { useSendRejectedTaxSubmission } from "../../../../../../core/api/use-send-rejected-tax-submission/useSendRejectedTaxSubmission";
import { SendRejectedTaxSubmissionModal } from "../../send-rejected-tax-submission-modal/SendRejectedTaxSubmissionModal";

export const useGetCtaSendRejectedTaxSubmission = (
    onTaxSubmissionUpdate: () => unknown,
    taxSubmissionDetail: TaxSubmissionDetailDTO,
) => {
    const { t } = useTranslation();
    const [sendRejectedModalOpen, setSendRejectedModalOpen] = useState(false);

    const { mutateAsync, isPending } = useSendRejectedTaxSubmission();

    const onClickSendRejected = async () => {
        await mutateAsync({ taxSubmissionId: taxSubmissionDetail.id });
        onTaxSubmissionUpdate();
    };

    return (
        <>
            <SendRejectedTaxSubmissionModal
                loading={isPending}
                onSend={onClickSendRejected}
                open={sendRejectedModalOpen}
                onClose={() => setSendRejectedModalOpen(false)}
            />
            <Button
                color="primary"
                disabled={
                    isPending ||
                    (taxSubmissionDetail.intermediary.type ===
                        IntermediaryType.COMPANY &&
                        !taxSubmissionDetail.delegatedTaxId)
                }
                startIcon={<VaporIcon icon={faShareAll} color="white" />}
                onClick={() => setSendRejectedModalOpen(true)}
                variant="contained"
            >
                {t(
                    "views.home.components.tax_submission_detail_toolbar.primary_cta.send_rejected_tax_submission",
                )}
            </Button>
        </>
    );
};
